import { render, staticRenderFns } from "./AddSaleTagModal.vue?vue&type=template&id=6b6f767d&"
import script from "./AddSaleTagModal.vue?vue&type=script&lang=js&"
export * from "./AddSaleTagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports